module.exports = __webpack_public_path__ + "static/media/Rectangle.356d6a6b.png";